// @flow
/* eslint-disable consistent-return */

import { showErrorMessage } from 'actions/errorMessage';
import { getRawAuthToken } from './auth';
import store from '../store';

const MESSAGE =
  'Hiba történt a szerverrel való kommunikáció során. Kérjük, próbáld újra később!';
const TOKEN_STORAGE_KEY = 'token';
const FEATURES_STORAGE_KEY = 'features';

function handleUnauthorized() {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
  localStorage.removeItem(FEATURES_STORAGE_KEY);
  window.location = '/w/login';
}

export default function fetch(url: string, props: ?Object) {
  const headers = (props && props.headers) || {};

  const token = getRawAuthToken();

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return window
    .fetch(url, { ...props, headers })
    .then(response => {
      if (response.ok) {
        return response;
      }

      if ((response.status === 401 || response.status === 403) && token) {
        handleUnauthorized();
        return Promise.reject(new Error('Unauthorized'));
      }

      if (window.Raven && window.Raven.captureException) {
        window.Raven.captureException('API call failed', { extra: { url, props } });
      }
      return Promise.reject(new Error(`API call failed with status ${response.status}`));
    })
    .catch(error => {
      if (error && error.message === 'Unauthorized') {
        return Promise.reject(error);
      }

      store.dispatch(showErrorMessage(MESSAGE));
      return Promise.reject(error || new Error('API call failed'));
    });
}



// WEBPACK FOOTER //
// ./utils/fetch.js